import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Resource } from '../../shared/document-sync';

@Component({
  selector: 'app-image-display-dialog',
  templateUrl: './image-display-dialog.component.html',
  styleUrls: ['./image-display-dialog.component.scss'],
  standalone: false
})
export class ImageDisplayDialogComponent implements OnInit {
  public title: string
  public images: Resource[] = [];
  public trustedUrl: SafeUrl = undefined;
  public currentIndex = 0;
  public hasPrevious = false;
  public hasNext = false;

  constructor(
    public dialogRef: MatDialogRef<ImageDisplayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    this.title = this.data.title;
    this.images = this.data.images;
  }

  ngOnInit() {
    if (this.images && this.images.length > 0) {
      this.loadImage(0);
    }
  }

  public loadImage(index: number): void {
    // determine where in loop image should be pulled so it is within range
    if (index < this.images.length && index > -1) {
      this.currentIndex = index;
    } else if (index >= this.images.length) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = this.images.length - 1;
    }
    const imageResource = this.images[this.currentIndex];
    if (imageResource) {
      this.setTrustedUrl(imageResource);
    }
  }

  private setTrustedUrl(resource: Resource): void {
    if (resource && resource.hls_url) {
      this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(resource.hls_url);
    }
  }

}
